import React, { useState, useEffect } from 'react';

const EasterSceneOverlay = () => {
  const [butterflies, setButterflies] = useState([]);

  useEffect(() => {
    // Create flying butterflies
    const butterflyCount = 8;
    const initialButterflies = Array.from({ length: butterflyCount }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: 20 + Math.random() * 40,
      duration: 15 + Math.random() * 10,
      delay: Math.random() * 5,
    }));
    setButterflies(initialButterflies);
  }, []);

  return (
    <div className="easter-scene-overlay">
      <style>
        {`
        .easter-scene-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
          pointer-events: none;
          overflow: hidden;
        }

        /* Bright spring sky with sunshine */
        .spring-sky {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            to bottom,
            #87ceeb 0%,
            #a8d8f0 30%,
            #c8e8ff 60%,
            #e0f4ff 80%,
            #f0f8ff 100%
          );
          z-index: 0;
        }

        /* Sunshine rays */
        .sun-rays {
          position: absolute;
          top: 10%;
          right: 15%;
          width: 200px;
          height: 200px;
          z-index: 1;
        }

        .sun {
          position: absolute;
          width: 100px;
          height: 100px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: radial-gradient(circle, #ffeb3b 0%, #ffd700 40%, #ffa500 100%);
          border-radius: 50%;
          box-shadow: 0 0 60px rgba(255, 215, 0, 0.8);
          animation: sunGlow 3s ease-in-out infinite;
        }

        @keyframes sunGlow {
          0%, 100% { 
            box-shadow: 0 0 60px rgba(255, 215, 0, 0.8);
          }
          50% { 
            box-shadow: 0 0 90px rgba(255, 215, 0, 1);
          }
        }

        .sun-ray {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 4px;
          height: 80px;
          background: linear-gradient(to top, rgba(255, 235, 59, 0.6), transparent);
          transform-origin: bottom center;
          animation: rayRotate 20s linear infinite;
        }

        @keyframes rayRotate {
          0% { transform: translate(-50%, -100%) rotate(0deg); }
          100% { transform: translate(-50%, -100%) rotate(360deg); }
        }

        /* White fluffy clouds */
        .cloud {
          position: absolute;
          background: white;
          border-radius: 100px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
          animation: cloudFloat linear infinite;
          z-index: 2;
        }

        @keyframes cloudFloat {
          0% { transform: translateX(0); }
          100% { transform: translateX(-120vw); }
        }

        .cloud::before,
        .cloud::after {
          content: '';
          position: absolute;
          background: white;
          border-radius: 100px;
        }

        /* Easter bunny */
        .easter-bunny {
          position: absolute;
          bottom: 25%;
          left: 15%;
          width: 120px;
          height: 160px;
          z-index: 5;
          animation: bunnyHop 3s ease-in-out infinite;
        }

        @keyframes bunnyHop {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }

        .bunny-body {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 70px;
          height: 80px;
          background: radial-gradient(ellipse at 40% 40%, #ffffff 0%, #f8f8f8 60%, #f0f0f0 100%);
          border-radius: 50% 50% 45% 45%;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
        }

        .bunny-head {
          position: absolute;
          bottom: 60px;
          left: 50%;
          transform: translateX(-50%);
          width: 55px;
          height: 55px;
          background: radial-gradient(ellipse at 40% 40%, #ffffff 0%, #f8f8f8 60%, #f0f0f0 100%);
          border-radius: 50%;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
        }

        .bunny-ear {
          position: absolute;
          bottom: 100px;
          width: 16px;
          height: 50px;
          background: linear-gradient(to bottom, #ffffff 0%, #f8f8f8 60%, #f0f0f0 100%);
          border-radius: 50% 50% 0 0;
        }

        .bunny-ear.left {
          left: 30px;
          transform: rotate(-10deg);
        }

        .bunny-ear.right {
          right: 30px;
          transform: rotate(10deg);
        }

        .bunny-ear-inner {
          position: absolute;
          top: 5px;
          left: 50%;
          transform: translateX(-50%);
          width: 8px;
          height: 35px;
          background: #ffb6c1;
          border-radius: 50% 50% 0 0;
        }

        .bunny-eye {
          position: absolute;
          top: 20px;
          width: 6px;
          height: 8px;
          background: #2c1810;
          border-radius: 50%;
        }

        .bunny-eye.left {
          left: 15px;
        }

        .bunny-eye.right {
          right: 15px;
        }

        .bunny-nose {
          position: absolute;
          top: 30px;
          left: 50%;
          transform: translateX(-50%);
          width: 8px;
          height: 6px;
          background: #ffb6c1;
          border-radius: 50% 50% 50% 50%;
        }

        .bunny-whiskers {
          position: absolute;
          top: 28px;
          left: 50%;
          transform: translateX(-50%);
          width: 60px;
          height: 2px;
        }

        .whisker {
          position: absolute;
          width: 20px;
          height: 1px;
          background: #888;
        }

        /* Woven basket */
        .easter-basket {
          position: absolute;
          bottom: 20%;
          right: 15%;
          width: 140px;
          height: 100px;
          z-index: 4;
        }

        .basket-body {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 70px;
          background: linear-gradient(135deg, #d2691e 0%, #a0522d 50%, #8b4513 100%);
          border-radius: 10px 10px 15px 15px;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
        }

        .basket-weave {
          position: absolute;
          width: 100%;
          height: 3px;
          background: rgba(139, 69, 19, 0.4);
        }

        .basket-handle {
          position: absolute;
          top: 0;
          left: 20px;
          width: 100px;
          height: 50px;
          border: 6px solid #a0522d;
          border-bottom: none;
          border-radius: 50px 50px 0 0;
          box-shadow: 0 -3px 10px rgba(0, 0, 0, 0.2);
        }

        /* Colorful Easter eggs */
        .easter-egg {
          position: absolute;
          border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
          animation: eggWobble ease-in-out infinite;
        }

        @keyframes eggWobble {
          0%, 100% { transform: rotate(-1deg); }
          50% { transform: rotate(1deg); }
        }

        .egg-stripe {
          position: absolute;
          left: 0;
          width: 100%;
          height: 8px;
          border-radius: 50%;
        }

        .egg-dot {
          position: absolute;
          width: 8px;
          height: 8px;
          border-radius: 50%;
        }

        .egg-zigzag {
          position: absolute;
          left: 0;
          width: 100%;
          height: 10px;
          background-size: 10px 10px;
        }

        /* Spring flowers */
        .flower-field {
          position: absolute;
          bottom: 15%;
          width: 100%;
          height: 20%;
          z-index: 3;
        }

        .spring-flower {
          position: absolute;
          animation: flowerSway ease-in-out infinite;
        }

        @keyframes flowerSway {
          0%, 100% { transform: rotate(-2deg); }
          50% { transform: rotate(2deg); }
        }

        .flower-stem {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 3px;
          height: 40px;
          background: linear-gradient(180deg, #228b22 0%, #006400 100%);
        }

        .flower-petals {
          position: absolute;
          bottom: 35px;
          left: 50%;
          transform: translateX(-50%);
          width: 30px;
          height: 30px;
        }

        .petal {
          position: absolute;
          width: 12px;
          height: 12px;
          border-radius: 50% 0 50% 0;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
        }

        .flower-center {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 10px;
          height: 10px;
          background: radial-gradient(circle, #ffd700 0%, #ffb347 100%);
          border-radius: 50%;
        }

        /* Butterflies */
        .butterfly {
          position: absolute;
          width: 30px;
          height: 25px;
          z-index: 8;
          animation: butterflyFly ease-in-out infinite;
        }

        @keyframes butterflyFly {
          0%, 100% { 
            transform: translateY(0) rotate(0deg);
          }
          25% { 
            transform: translateY(-10px) rotate(5deg);
          }
          50% { 
            transform: translateY(-15px) rotate(0deg);
          }
          75% { 
            transform: translateY(-10px) rotate(-5deg);
          }
        }

        .butterfly-wing {
          position: absolute;
          width: 15px;
          height: 20px;
          border-radius: 50% 0 50% 0;
          animation: wingFlap 0.3s ease-in-out infinite;
        }

        .butterfly-wing.left {
          left: 0;
          transform-origin: right center;
          background: linear-gradient(135deg, #ff6b9d 0%, #ffa500 50%, #ffeb3b 100%);
        }

        .butterfly-wing.right {
          right: 0;
          transform-origin: left center;
          transform: scaleX(-1);
          background: linear-gradient(135deg, #ff6b9d 0%, #ffa500 50%, #ffeb3b 100%);
        }

        @keyframes wingFlap {
          0%, 100% { transform: rotateY(0deg); }
          50% { transform: rotateY(20deg); }
        }

        .butterfly-body {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 3px;
          height: 20px;
          background: #2c1810;
          border-radius: 50px;
        }

        /* Green grass meadow */
        .spring-meadow {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 25%;
          background: linear-gradient(
            to bottom,
            #7ec850 0%,
            #68b838 50%,
            #5aa028 100%
          );
          z-index: 6;
          box-shadow: 0 -15px 40px rgba(124, 200, 80, 0.3);
        }

        .grass-blade {
          position: absolute;
          bottom: 0;
          width: 3px;
          height: 25px;
          background: linear-gradient(to top, #5aa028 0%, #7ec850 100%);
          border-radius: 50% 50% 0 0;
          transform-origin: bottom center;
          animation: grassSway ease-in-out infinite;
        }

        @keyframes grassSway {
          0%, 100% { transform: rotate(-2deg); }
          50% { transform: rotate(2deg); }
        }

        /* Easter egg hunt sign */
        .easter-sign {
          position: absolute;
          top: 20%;
          left: 50%;
          transform: translateX(-50%);
          width: 200px;
          height: 60px;
          background: linear-gradient(135deg, #ffb6c1 0%, #ff9db8 100%);
          border-radius: 30px;
          box-shadow: 0 8px 20px rgba(255, 105, 180, 0.4);
          z-index: 7;
          animation: signBounce ease-in-out infinite;
        }

        @keyframes signBounce {
          0%, 100% { transform: translateX(-50%) translateY(0); }
          50% { transform: translateX(-50%) translateY(-10px); }
        }

        .sign-text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: white;
          font-size: 24px;
          font-weight: bold;
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
          font-family: 'Comic Sans MS', cursive;
        }
        `}
      </style>

      {/* Spring sky */}
      <div className="spring-sky" />

      {/* Sun with rays */}
      <div className="sun-rays">
        <div className="sun" />
        {Array.from({ length: 12 }, (_, i) => (
          <div
            key={i}
            className="sun-ray"
            style={{
              transform: `translate(-50%, -100%) rotate(${i * 30}deg)`,
            }}
          />
        ))}
      </div>

      {/* Fluffy clouds */}
      {[
        { width: 100, height: 40, top: '15%', left: '20%', duration: 60 },
        { width: 120, height: 45, top: '25%', left: '70%', duration: 70 },
        { width: 90, height: 35, top: '35%', left: '40%', duration: 65 },
      ].map((cloud, i) => (
        <div
          key={i}
          className="cloud"
          style={{
            width: `${cloud.width}px`,
            height: `${cloud.height}px`,
            top: cloud.top,
            left: cloud.left,
            animationDuration: `${cloud.duration}s`,
            animationDelay: `${i * 10}s`,
          }}
        >
          <div style={{
            width: `${cloud.width * 0.5}px`,
            height: `${cloud.height * 0.8}px`,
            top: `${cloud.height * -0.3}px`,
            left: `${cloud.width * 0.1}px`,
          }} />
          <div style={{
            width: `${cloud.width * 0.6}px`,
            height: `${cloud.height * 0.9}px`,
            top: `${cloud.height * -0.4}px`,
            left: `${cloud.width * 0.3}px`,
          }} />
        </div>
      ))}

      {/* Easter bunny */}
      <div className="easter-bunny">
        <div className="bunny-ear left">
          <div className="bunny-ear-inner" />
        </div>
        <div className="bunny-ear right">
          <div className="bunny-ear-inner" />
        </div>
        <div className="bunny-head">
          <div className="bunny-eye left" />
          <div className="bunny-eye right" />
          <div className="bunny-nose" />
          <div className="bunny-whiskers">
            <div className="whisker" style={{ left: '-10px', top: '0', transform: 'rotate(-10deg)' }} />
            <div className="whisker" style={{ left: '-10px', top: '4px', transform: 'rotate(-5deg)' }} />
            <div className="whisker" style={{ right: '-10px', top: '0', transform: 'rotate(10deg)' }} />
            <div className="whisker" style={{ right: '-10px', top: '4px', transform: 'rotate(5deg)' }} />
          </div>
        </div>
        <div className="bunny-body" />
      </div>

      {/* Easter basket with eggs */}
      <div className="easter-basket">
        <div className="basket-handle" />
        <div className="basket-body">
          {/* Basket weave pattern */}
          {[15, 30, 45, 60].map((pos) => (
            <div key={pos} className="basket-weave" style={{ bottom: `${pos}%` }} />
          ))}
        </div>
        
        {/* Eggs in basket */}
        {[
          { x: 20, y: 45, color: '#ff6b9d', pattern: 'stripe', size: 35 },
          { x: 55, y: 50, color: '#87ceeb', pattern: 'dot', size: 40 },
          { x: 85, y: 48, color: '#98fb98', pattern: 'zigzag', size: 36 },
          { x: 38, y: 25, color: '#ffd700', pattern: 'stripe', size: 32 },
          { x: 68, y: 28, color: '#ffb6c1', pattern: 'dot', size: 34 },
        ].map((egg, i) => (
          <div
            key={i}
            className="easter-egg"
            style={{
              left: `${egg.x}px`,
              bottom: `${egg.y}px`,
              width: `${egg.size}px`,
              height: `${egg.size * 1.2}px`,
              background: `linear-gradient(135deg, ${egg.color} 0%, ${egg.color}dd 100%)`,
              animationDuration: '3s',
              animationDelay: `${i * 0.3}s`,
            }}
          >
            {egg.pattern === 'stripe' && (
              <>
                <div className="egg-stripe" style={{ top: '30%', background: 'rgba(255, 255, 255, 0.4)' }} />
                <div className="egg-stripe" style={{ top: '60%', background: 'rgba(255, 255, 255, 0.4)' }} />
              </>
            )}
            {egg.pattern === 'dot' && (
              <>
                <div className="egg-dot" style={{ top: '25%', left: '20%', background: 'rgba(255, 255, 255, 0.5)' }} />
                <div className="egg-dot" style={{ top: '45%', left: '40%', background: 'rgba(255, 255, 255, 0.5)' }} />
                <div className="egg-dot" style={{ top: '65%', left: '25%', background: 'rgba(255, 255, 255, 0.5)' }} />
                <div className="egg-dot" style={{ top: '40%', left: '70%', background: 'rgba(255, 255, 255, 0.5)' }} />
              </>
            )}
            {egg.pattern === 'zigzag' && (
              <div className="egg-zigzag" style={{
                top: '40%',
                backgroundImage: 'linear-gradient(45deg, rgba(255, 255, 255, 0.4) 25%, transparent 25%, transparent 75%, rgba(255, 255, 255, 0.4) 75%)',
              }} />
            )}
          </div>
        ))}
      </div>

      {/* Spring flowers scattered */}
      <div className="flower-field">
        {[
          { x: 10, y: 60, color: '#ffeb3b', delay: 0 },
          { x: 25, y: 40, color: '#ffa500', delay: 0.5 },
          { x: 40, y: 70, color: '#ff69b4', delay: 1 },
          { x: 55, y: 50, color: '#ffeb3b', delay: 1.5 },
          { x: 70, y: 65, color: '#ff1493', delay: 2 },
          { x: 85, y: 45, color: '#ffa500', delay: 2.5 },
          { x: 30, y: 20, color: '#ff69b4', delay: 3 },
          { x: 65, y: 30, color: '#ffeb3b', delay: 3.5 },
        ].map((flower, i) => (
          <div
            key={i}
            className="spring-flower"
            style={{
              left: `${flower.x}%`,
              bottom: `${flower.y}%`,
              animationDuration: '4s',
              animationDelay: `${flower.delay}s`,
            }}
          >
            <div className="flower-stem" />
            <div className="flower-petals">
              {[0, 72, 144, 216, 288].map((angle, j) => (
                <div
                  key={j}
                  className="petal"
                  style={{
                    background: flower.color,
                    transform: `translate(-50%, -50%) rotate(${angle}deg) translateY(-8px)`,
                    top: '50%',
                    left: '50%',
                  }}
                />
              ))}
              <div className="flower-center" />
            </div>
          </div>
        ))}
      </div>

      {/* Butterflies flying */}
      {butterflies.map((butterfly) => (
        <div
          key={butterfly.id}
          className="butterfly"
          style={{
            left: `${butterfly.x}%`,
            top: `${butterfly.y}%`,
            animationDuration: '2s',
            animationDelay: `${butterfly.delay}s`,
          }}
        >
          <div className="butterfly-wing left" />
          <div className="butterfly-wing right" />
          <div className="butterfly-body" />
        </div>
      ))}

      {/* Green spring meadow */}
      <div className="spring-meadow">
        {/* Grass blades */}
        {Array.from({ length: 50 }, (_, i) => (
          <div
            key={i}
            className="grass-blade"
            style={{
              left: `${i * 2}%`,
              height: `${15 + Math.random() * 15}px`,
              animationDuration: `${2 + Math.random() * 2}s`,
              animationDelay: `${Math.random() * 2}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default EasterSceneOverlay;
